// @ts-nocheck

import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { withUserAccess } from '../withUserAccess';

import ExpenseDirectionList from './ExpenseDirection/ExpenseDirectionList';
import ExpenseDirectionForm from './ExpenseDirection/ExpenseDirectionForm';

import BudgetLineItemList from './BudgetLineItem/List';
import BudgetLineItemForm from './BudgetLineItem/Form';
import { RouteComponent } from '../../lib/routerAdapter';

export default withUserAccess(({ userAccess }) => {
  return (
    <>
      <Routes>
        <Route index element={<RouteComponent component={ExpenseDirectionList} />} />
        <Route path="new" element={<RouteComponent component={ExpenseDirectionForm} />} />
        <Route path=":expenseDirectionId/edit" element={<RouteComponent component={ExpenseDirectionForm} />} />

        <Route path="budget-line-item" element={<RouteComponent component={BudgetLineItemList} />} />
        <Route path="budget-line-item/new" element={<RouteComponent component={BudgetLineItemForm} />} />
        <Route path="budget-line-item/:id/edit" element={<RouteComponent component={BudgetLineItemForm} />} />
      </Routes>
    </>);

});
